import { useContext } from "react";

import { SkeletonCircle } from "@chakra-ui/react";

import { Text, HStack, VStack } from "../../internal/exports";
import { SkeletonText } from "../../skeleton/skeleton-text";
import { Avatar } from "../../avatar/avatar";

import { ContributionContext } from "../context";

export function Header({ hideActionList }: { hideActionList?: boolean }) {
  const {
    username,
    userAvatarSrc,
    isLoaded,
    contributionTime,
    showMoreOptions,
    actionList,
    hideHeader
  } = useContext(ContributionContext);

  if (hideHeader) return null;

  if (!isLoaded) {
    return (
      <HStack justify="space-between">
        <HStack w="full">
          <SkeletonCircle w="2.75rem" h={10} />
          <VStack w="full" align="start">
            <SkeletonText w="80%" noOfLines={1} skeletonHeight={2} />
            <SkeletonText w="50%" noOfLines={1} skeletonHeight={1} />
          </VStack>
        </HStack>
      </HStack>
    );
  }

  return (
    <HStack justify="space-between">
      <HStack>
        <Avatar
          name={username}
          src={userAvatarSrc}
          aria-hidden="true"
          data-testid="card-avatarImage"
        />
        <VStack w="full" gap={0} align="start">
          <Text
            lineClamp={1}
            fontSize="sm"
            fontWeight="semibold"
            data-testid="card-usernameText"
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            maxW={{ base: 240, md: 200 }}
          >
            {username}
          </Text>
          <Text
            fontSize="xs"
            lineClamp={1}
            fontWeight="medium"
            data-testid="card-contributionTimeText"
          >
            {contributionTime}
          </Text>
        </VStack>
      </HStack>
      {isLoaded && !hideActionList && (
        <HStack gap={2}>{showMoreOptions && actionList}</HStack>
      )}
    </HStack>
  );
}
